// pull in config vars
import * as config from "../config"
import fetch from "isomorphic-fetch"

interface Result {
	// TODO: What is the shape of the returned JSON?
}

export default async function sendUserOtp(
	JAM_ID: string,
	email: string,
): Promise<Result | false> {
	try {
		const res = await fetch(`${config.API_HOSTNAME}/api/otp/new`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ email }),
		})

		const json = await res.json()

		return json
	} catch (e) {
		return false
	}
}
